import MoreVertIcon from "@mui/icons-material/MoreVert";
import WarningIcon from "@mui/icons-material/Warning";
import { Box, IconButton, Menu, MenuItem, TableCell, TableRow, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { capitalize } from "shared-ui/utils/capitalize";
import { DiningStationTemplateTableFragment } from "../../types";

interface DiningStationTemplateRowProps {
  row: DiningStationTemplateTableFragment;
  onEdit: (id: string) => void;
  onDelete: (row: DiningStationTemplateTableFragment) => void;
  onDuplicate: (row: string) => void;
}

export const DiningStationTemplateRow = ({ row, onEdit, onDelete, onDuplicate }: DiningStationTemplateRowProps) => {
  const [actionsMenu, setActionsMenu] = useState<HTMLElement | null>(null);
  const { name, id, menuItemAppearances, mealTypes } = row;

  const menuItemIdsWithoutIngredients = menuItemAppearances.flatMap(mia =>
    mia.menuItem.isMissingIngredients && mia.menuItem.isOneOff ? mia.menuItem.id : []
  );
  const isMissingIngredients = menuItemIdsWithoutIngredients.length > 0;

  return (
    <>
      <TableRow key={id} hover onClick={() => onEdit(id)} sx={{ cursor: "pointer" }}>
        <TableCell scope="row">
          {isMissingIngredients ? (
            <Box sx={{ display: "flex" }}>
              <Tooltip
                title={
                  <Typography variant="subtitle1">
                    One-off menu items are missing ingredients. This will affect food log data from menu orders.
                  </Typography>
                }
              >
                <WarningIcon fontSize="small" color="warning" />
              </Tooltip>
              <Box sx={{ display: "flex", alignItems: "center", pl: 0.5 }}>{name}</Box>
            </Box>
          ) : (
            name
          )}
        </TableCell>
        <TableCell>{mealTypes.map(capitalize).join(", ")}</TableCell>
        <TableCell align="left">{menuItemAppearances.length}</TableCell>
        <TableCell>
          <IconButton
            size="small"
            onClick={e => {
              e.stopPropagation();
              setActionsMenu(e.currentTarget);
            }}
            aria-label={`Open actions for ${name}`}
          >
            <MoreVertIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <Menu
        anchorEl={actionsMenu}
        open={!!actionsMenu}
        onClose={() => {
          setActionsMenu(null);
        }}
        keepMounted
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          dense
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            setActionsMenu(null);
            onDelete(row);
          }}
        >
          Delete
        </MenuItem>
        <MenuItem
          dense
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            setActionsMenu(null);
            onDuplicate(id);
          }}
        >
          Duplicate
        </MenuItem>
      </Menu>
    </>
  );
};
